<template>
  <div
    class="asc-report-alert-wrapper"
    data-automation-id="wrapper_report_alert"
  >
    <asc-accordion :value="1">
      <asc-accordion-item>
        <template slot="header">
          <asc-section-header title="Alerts"></asc-section-header>
        </template>
        <asc-alert-list
          :values="values"
          :loading="loading"
          :on-report-alert-click="onReportAlertClick"
        ></asc-alert-list>
      </asc-accordion-item>
    </asc-accordion>
  </div>
</template>

<script>
import AscAccordion from '@/components/atoms/AscAccordion'
import AscAccordionItem from '@/components/atoms/AscAccordionItem'
import AscSectionHeader from '@/components/atoms/AscSectionHeader'
import { AscReportAlertMixin } from '@/components/mixins'
import AscAlertList from '@/components/molecules/AscAlertList'

export default {
  name: 'AscReportAlertWrapper',

  components: {
    AscAccordion,
    AscAccordionItem,
    AscSectionHeader,
    AscAlertList,
  },

  mixins: [AscReportAlertMixin],

  props: {
    values: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    getCount() {
      if (this.values) {
        const alarmCount = this.values.filter(item => item.alertEnabled)
        return alarmCount.length.toString()
      }

      return '0'
    },
  },
}
</script>

<style lang="scss" scoped>
.asc-report-alert-wrapper {
  background-color: $primary-white;
  margin-bottom: 16px !important;
}
</style>
